import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAperture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M15.176 7.5a1 1 0 0 0-1.732 1zm4.008 10.94a1 1 0 0 0 1.732-1zM9.69 7a1 1 0 1 0 0 2zm11.48 2a1 1 0 1 0 0-2zM6.514 11.5a1 1 0 0 0 1.732 1zm7.472-8.94a1 1 0 0 0-1.732-1zM8.824 16.5a1 1 0 0 0 1.732-1zM4.816 5.56a1 1 0 1 0-1.732 1zM14.31 17a1 1 0 1 0 0-2zM2.83 15a1 1 0 1 0 0 2zm14.656-2.5a1 1 0 0 0-1.732-1zm-7.472 8.94a1 1 0 0 0 1.732 1zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm1.444 5.5 5.74 9.94 1.732-1-5.74-9.94zM9.69 9h11.48V7H9.69zm-1.444 3.5 5.74-9.94-1.732-1-5.74 9.94zm2.31 3-5.74-9.94-1.732 1 5.74 9.94zm3.754-.5H2.83v2h11.48zm1.444-3.5-5.74 9.94 1.732 1 5.74-9.94z'
    />
  </svg>
);
export default SvgAperture;
